// extracted by mini-css-extract-plugin
module.exports = {"infoWrapper":"ClientEmergencyInfo_infoWrapper__OWLqC","itemTitle":"ClientEmergencyInfo_itemTitle__30zdF","itemText":"ClientEmergencyInfo_itemText__2WtH3"};